// extracted by mini-css-extract-plugin
export default {"layout":"AuthContainer_layout__+9S00","sider":"AuthContainer_sider__W8lna","logo":"AuthContainer_logo__lKDgC"};